export const AssetImages = {
  LOGO: require("../assets/logo.png"),
  QRCODE: require("../assets/qrCode.png"),
  CHPLAY: require("../assets/chplay.png"),
  APPSTORE: require("../assets/appstore.png"),
  IMAGES_FAKE: {
    IMAGE_1: require("../assets/bar-1.jpg"),
    IMAGE_2: require("../assets/bar-2.jpg"),
    IMAGE_3: require("../assets/breakfast-1.jpg"),
    IMAGE_4: require("../assets/breakfast-2.jpg"),
    IMAGE_5: require("../assets/fitness-center-1.jpg"),
    IMAGE_6: require("../assets/fitness-center-2.jpg"),
    IMAGE_7: require("../assets/pool-1.jpg"),
  },
  AVT_FAKE: {
    AVT_1: require("../assets/avatar/avt-1.jpeg"),
    AVT_2: require("../assets/avatar/avt-2.jpeg"),
    AVT_3: require("../assets/avatar/avt-3.jpeg"),
    HIEUNT: require("../assets/avatar/HieuNT.jpg"),
    BAOTQ: require("../assets/avatar/BaoTQ.jpg"),
    DATNT: require("../assets/avatar/DatNT.jpg"),
    THANHVD: require("../assets/avatar/ThanhVD.jpg"),
    QUOCNA: require("../assets/avatar/QuocNA.jpg"),
    HIEUDM: require("../assets/avatar/HieuDM.jpg"),
  },
  BANNER: {
    BANNER_1: require("../assets/ImageSlider/photo.jpg"),
    BANNER_2: require("../assets/ImageSlider/photo-1.jpg"),
    BANNER_3: require("../assets/ImageSlider/photo-2.jpg"),
    BANNER_4: require("../assets/ImageSlider/photo-3.jpg"),
    BANNER_5: require("../assets/ImageSlider/photo-4.jpg"),
  },
  Google: require("../assets/Google.png"),
  ICONS: {
    COMMENT_AVATAR: require("../assets/icons/comment-icon.png"),
    COMMENT_SEND: require("../assets/icons/comment-send.png"),
    MOMENT_AVATAR: require("../assets/moment_avatar.png"),
    REMOVE_IMAGE: require("../assets/icons/remove-image.png"),
    SIZEROOM2: require("../assets/icons/size-room-2.png"),
    PEOPLE: require("../assets/icons/people.png"),

    PHONE: require("../assets/icons/footer/phone.png"),
    MAIL: require("../assets/icons/footer/mail.png"),
    LOCATION: require("../assets/icons/footer/location.png"),
    RIGHT: require("../assets/icons/footer/arrow-right.png"),
    USER: require("../assets/icons/user.png"),
    LOCATION_2: require("../assets/icons/location-2.png"),
    STAR: require("../assets/icons/star.png"),
    BED: require("../assets/icons/bed.png"),
    NON_SMOKING: require("../assets/icons/non-smoking.png"),
    SIZE_ROOM: require("../assets/icons/size-room.png"),
    BALCONY: require("../assets/icons/balcony.png"),
    RIVER_VIEW: require("../assets/icons/river-view.png"),
    BATHTUB: require("../assets/icons/bathtub.png"),
    BED_2: require("../assets/icons/bed-2.png"),
    CALENDAR: require("../assets/icons/calendar.png"),
    INTERNET: require("../assets/icons/wi-fi.png"),
    PARKING: require("../assets/icons/parking.png"),
    PLANE: require("../assets/icons/plane.png"),
    BAG: require("../assets/icons/bag.png"),
    DINING: require("../assets/icons/dining.png"),
    CHECKED: require("../assets/icons/checked.png"),

    ADMIN: {
      DASHBOARD: require("../assets/icons/admin/dashboard.png"),
      HOTEL: require("../assets/icons/admin/hotel.png"),
      INFORMATION: require("../assets/icons/admin/information.png"),
      REPORT: require("../assets/icons/admin/report.png"),
      FORM: require("../assets/icons/admin/form.png"),
      ACCOUNT: require("../assets/icons/admin/account.png"),
      MOMENT: require("../assets/icons/admin/moment.png"),
      VOUCHER: require("../assets/icons/admin/voucher.png"),
    },

    ROOM_SERVICES: {
      TOILET: require("../assets/icons/room-amenities/toiletries.png"),
      ROOM_LAYOUT: require("../assets/icons/room-amenities/room-layout.png"),
      CLEANING: require("../assets/icons/room-amenities/cleaning.png"),
      BATHROOM: require("../assets/icons/room-amenities/bathroom.png"),
      OUTDOOR: require("../assets/icons/room-amenities/pool.png"),
      FOOD: require("../assets/icons/room-amenities/food.png"),
    },
  },
  MOMENTS: {
    MOMENT_1: require("../assets/moment-cho-noi.png"),
    MOMENT_2: require("../assets/moment-cho-noi-2.png"),
    MOMENT_3: require("../assets/moment-ben-ninh-kieu.png"),
    ANOTHER_MOMENT_1: require("../assets/another_moment.png"),
    ANOTHER_MOMENT_2: require("../assets/another_moment-2.png"),
    ANOTHER_MOMENT_3: require("../assets/another_moment-3.png"),
    ANOTHER_MOMENT_4: require("../assets/another_moment-4.png"),
    BANNER_1: require("../assets/BannerMD-1.png"),
    BANNER_2: require("../assets/BannerMD-2.png"),
    BANNER_3: require("../assets/BannerMD-3.png"),
    BANNER_4: require("../assets/Banner_MD4.jpg"),
    CAMERA: require("../assets/createMoment-camera.png"),
  },
  ABOUT_US: {
    HEADER: require("../assets/aboutUs.jpg"),
    MISSION: require("../assets/about_us_mission.jpg"),
    STORY: require("../assets/about_us_story.jpg"),
  },
};
